export const importLiabilitiesDataGridConfig = {
  isRowSelectable: true,
  allowEdit: false,
  hasChildGridTable: false,
  columns: [
    // {
    //   name: "Liability Basis Type Id",
    //   fieldName: "liabilityBasisTypeid",
    //   colStyle: {
    //     textAlign: "left",
    //     width: "18%",
    //   },
    //   allowShort: true,
    // },
    {
      name: "Liability Type",
      fieldName: "liabilityType",
      colStyle: {
        textAlign: "left",
        width: "20%",
      },
      allowShort: true,
    },
    {
      name: "Basis Type",
      fieldName: "basisType",
      colStyle: {
        textAlign: "left",
        width: "60%",
      },
      allowShort: true,
    },
    {
      name: "Liab Prefix",
      fieldName: "liabPrefix",
      colStyle: {
        textAlign: "left",
        width: "10%",
      },
      allowShort: true,
    },
    {
      name: "Basis Prefix",
      fieldName: "basisPrefix",
      colStyle: {
        textAlign: "left",
        width: "10%",
      },
      allowShort: true,
    },
  ],
};


export const previewLiabilitiesDataGridConfig = {
  isRowSelectable: false,
  allowEdit: false,
  hasChildGridTable: false,
  columns: [
    {
      name: "S No.",
      fieldName: "sNo",
      colStyle: {
        textAlign: "left",
        width: "10%",
      },
      allowShort: false,
    },
    {
      name: "A",
      fieldName: "passInfo",
      colStyle: {
        textAlign: "left",
        width: "10%",
      },
      allowShort: false,
    },
    {
      name: "B",
      fieldName: "valData",
      colStyle: {
        textAlign: "left",
        width: "10%",
      },
      allowShort: false,
    },
    {
      name: "C",
      fieldName: "pass",
      colStyle: {
        textAlign: "left",
        width: "10%",
        display: "block",
      },
      allowShort: false,
    },
    {
      name: "D",
      fieldName: "preRentInt",
      colStyle: {
        textAlign: "left",
        width: "10%",
      },
      allowShort: false,
    },
    {
      name: "E",
      fieldName: "postRentInt",
      colStyle: {
        textAlign: "left",
        width: "10%",
      },
      allowShort: false,
    },
    {
      name: "F",
      fieldName: "salScalF",
      colStyle: {
        textAlign: "left",
        width: "10%",
      },
      allowShort: false,
    },
    {
      name: "G",
      fieldName: "marriedM",
      colStyle: {
        textAlign: "left",
        width: "10%",
      },
      allowShort: false,
    },
    {
      name: "H",
      fieldName: "marriedF",
      colStyle: {
        textAlign: "left",
        width: "10%",
      },
      allowShort: false,
    },
    {
      name: "I",
      fieldName: "marriedF",
      colStyle: {
        textAlign: "left",
        width: "10%",
      },
      allowShort: false,
    },
    {
      name: "J",
      fieldName: "marriedF",
      colStyle: {
        textAlign: "left",
        width: "10%",
      },
      allowShort: false,
    },
    
  ],
};

